/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Area_Camera_EditInputs */

const vi_grower_area_camera_edit = /** @type {(inputs: Grower_Area_Camera_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sửa`)
};

/**

* @param {Grower_Area_Camera_EditInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_area_camera_edit = /** @type {((inputs?: Grower_Area_Camera_EditInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Area_Camera_EditInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_area_camera_edit(inputs)
});